import type { UserDisplayMode as UserDisplayModeType } from '@/constants/enums/UserDisplayMode'

import { useAuthStore } from '@/stores/authStore'

/**
 * Types
 */
type UseUserDisplayModeSwitch = (
  setUserDisplayMode: (newUserDisplayMode: UserDisplayModeType) => void,
  saveUserDisplayMode: (newUserDisplayMode: UserDisplayModeType) => void,
  navigateTo: (path: string) => void
) => {
  handleChangeUserDisplayMode: (value: UserDisplayModeType) => void
}

/**
 * ユーザーの表示モードを変更する
 * @param setUserDisplayMode - ユーザーの表示モードを変更する関数
 * @param saveUserDisplayMode - ユーザーの表示モードを保存する関数
 * @param guestBuyer
 * @param navigateTo - ページ遷移する関数
 * @returns void
 */
const handleChangeUserDisplayMode
  = (
    setUserDisplayMode: (newUserDisplayMode: UserDisplayModeType) => void,
    saveUserDisplayMode: (newUserDisplayMode: UserDisplayModeType) => void,
    guestBuyer: boolean | undefined,
    navigateTo: (path: string) => void,
  ) =>
    (value: UserDisplayModeType): void => {
      setUserDisplayMode(value)
      saveUserDisplayMode(value)

      if (value === 'buyer') {
        guestBuyer
          ? navigateTo('/mypage/buyer/datashare')
          : navigateTo('/mypage/evaluation/dashboard')
      }
      else if (value === 'supplier') {
        navigateTo('/mypage/dashboard')
      }
    }

/**
 * Composition
 */
export const useUserDisplayModeSwitch: UseUserDisplayModeSwitch = (
  setUserDisplayMode,
  saveUserDisplayMode,
  navigateTo,
) => {
  /**
   * Stores
   */
  const authStore = useAuthStore()

  return {
    handleChangeUserDisplayMode: handleChangeUserDisplayMode(
      setUserDisplayMode,
      saveUserDisplayMode,
      authStore.company?.contractPlans.guestBuyer,
      navigateTo,
    ),
  }
}
